import { Component } from '@angular/core'

import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'
import { AlertController } from 'ionic-angular'

import { debounceTime } from 'rxjs/operators/debounceTime'

import { Device, Condominium } from '../../models/models'

import { DeviceProvider } from '../../providers/device/device'
import { AuthProvider } from '../../providers/auth/auth'

import { ControlPanelPage } from '../control-panel/control-panel'

import { FormControl } from '@angular/forms'

@IonicPage()
@Component({
	selector: 'page-device-index',
	templateUrl: 'device-index.html',
})
export class DeviceIndexPage {
	/*
	Se non null indica il condominio di riferimento
	*/
	condominium: Condominium = null;
	isDevicesLoading = true;
	searchTerm: string

	searchControl: FormControl

	allDevices: Device[] = [];
	browsers: Device[] = [];
	intercoms: Device[] = [];
	dashboards: Device[] = [];
	smartphones: Device[] = [];

	/*
	salva l'eventuale condominio di riferimento
	*/
	constructor(
		private alertCtrl: AlertController,
		private devices: DeviceProvider,
		private nav: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController,
		private auth: AuthProvider
	) {
		this.condominium = navParams.get('condominium')
		this.searchControl = new FormControl()
	}
	/*
		goToDeviceEdit(fab,device:Device){
			fab.close();
			this.nav.push(DeviceEditPage,{device:device});
		}

		goToDeviceShow(fab,device:Device){
			fab.close();
			this.nav.push(DeviceShowPage,{device:device});
		}
	*/
	/*
	Quando il DOM ha finito di caricare
	*/
	ionViewDidLoad() {
		let self = this

		this.searchControl.valueChanges
			.pipe(debounceTime(1000))
			.subscribe(search => {//quando cambia i termini di ricerca aspetta X millisecondi prima di fare un caricamento da web
				console.log("Filtro dispositivi: " + search)
				self.refreshDevices()
			})
	}
	public goToControlPanel() {
		this.nav.setRoot(ControlPanelPage)
	}
	/*
	quando sta per visualizzare o rivisualizzare la pagina
	*/
	ionViewWillEnter() {
		this.refreshDevices()//Quando visualizza la pagina aggiorna i dispositivi
	}

	/*
	quando cambiano i termini della ricerca
	*/
	onSearchInput() {//Quando cambia i termini di ricerca va immediatamente in loading
		this.isDevicesLoading = true
	}

	refreshDevices() {
		console.log('Refresh elenco dispositivi..')
		let self = this
		this.isDevicesLoading = true
		self.browsers = []
		self.intercoms = []
		self.dashboards = []
		self.smartphones = []
		self.allDevices = []
		this.devices.index(this.condominium, ['condominium', 'condominium.address'], undefined, this.searchTerm)
			.then((devices: Device[]) => {
				if(devices) {
					self.allDevices = devices

					for(let i in devices) {
						let d = devices[i]
						switch(d.type) {
							case 'browser':
								self.browsers.push(d)
								break
							case 'intercom':
								self.intercoms.push(d)
								break
							case 'dashboard':
								self.dashboards.push(d)
								break
							case 'smartphone':
								self.smartphones.push(d)
								break
							default:
								console.error('Tipo di dispositivo non riconosciuto: ' + d.type, d)
								break
						}
					}
				} else {
					let toast = self.toastCtrl.create({
						message: 'Potrebbe essersi verificato un errore recuperando i dispositivi',
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					})
					toast.present()
				}

				self.isDevicesLoading = false
			}).catch(error => {
				let toast = self.toastCtrl.create({
					message: 'Errore recuperando i dispositivi',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
				console.error('Errore recuperando i dispositivi:', error)
				self.isDevicesLoading = false
			})
	}

	showDestroyDeviceConfirm(fab, device) {
		fab.close()
		let self = this
		let confirm = this.alertCtrl.create({
			title: "Eliminare le impostazioni del dispositivo dal server?",
			message: "Vuoi davvero eliminare la configurazione remota del dispositivo '" + device.name + "' - '" + device.identifier + "'?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Elimina',
					handler: () => {
						self.devices.destroy(device).then((success: boolean) => {
							if(success) {
								let toast = self.toastCtrl.create({
									message: 'Dispositivo eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
							} else {
								let toast = self.toastCtrl.create({
									message: 'Potrebbe essersi verificato un errore eliminando il dispositivo',
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							this.refreshDevices()
						}).catch(error => {
							console.error('Errore cancellando la configurazione del dispositivo', error)
							let toast = self.toastCtrl.create({
								message: 'Errore eliminando il dispositivo',
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							this.refreshDevices()
						})
					}
				}
			]
		})
		confirm.present()
	}
}



// WEBPACK FOOTER //
// ./src/pages/device-index/device-index.ts